<template>
  <div
    class="ccrs-search-results-popup"
    v-if="searchResults != null"
  >
    <div
      class="ccrs-search-results-popup__results"
      v-show="searchResults.items.length > 0"
    >
      <div
        class="ccrs-search-results-popup__header"
      >
        <span>{{ $tv('Provider', 'ccrs') }}</span>
        <span>{{ $tv('category', 'breadcrumbs') }}</span>
        <span>{{ $tv('design', 'categories') }}</span>
      </div>
      <div class="ccrs-search-results-popup__content">
        <div
          v-for="(result, index) in searchResults.items"
          :key="index"
          @click="clickItem(result.item)"
          :class="{'selected': result.item.isSelected}"
        >
          <span>{{ result.item.ccrs_competitor.Name }}</span>
          <span>{{
            $tv(result.item.category.TechnicalName, 'categories')
          }}</span>
          <span>{{
            $tv(result.item.ccrs_competitordesign.Name, 'categories')
          }}</span>
        </div>
      </div>
    </div>
    <div
      v-show="searchResults.items.length === 0"
      class="overlay__noProducts"
    >
      <div class="h6">
        {{ $tv('NothingFoundUseSearch', 'searchResults') }}
        <nuxt-link
          :to="localePath({path: '/searchResults', query: {query: searchTerm}})"
        >
          {{ $tv('ProductSearch', 'searchResults') }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchResults: {
      type: Object,
      default() {
        return null
      }
    },
    searchTerm: {
      type: String,
      default() {
        return null
      }
    }
  },
  methods: {
    clickItem: function(item) {
      this.$emit('clickItem', item)
    }
  }
}
</script>

<style lang="scss">
.ccrs-search-results-popup {
  position: absolute;
  display: flex;
  flex-direction: column;
  box-shadow: 0 .188rem .375rem $color--nav__main--background;
  z-index: 9;
  overflow-y: auto;
  max-height: 32.044rem;

  &__results {
    background-color: $color__white;

    @include breakpoint-up($md) {
      width: 40rem;
    }
  }

  &__header {
    position: sticky;
    top: 0;
    display: flex;
    padding: $default-margin-padding-width;
    background-color: $color__white;

    span {
      color: $color__primary;
      width: 20.469rem;
      margin-right: $default-margin-padding-width * 1.5;
    }
  }

  .overlay__noProducts {
    padding: $default-margin-padding-width * 1.5 $default-margin-padding-width;
    background-color: $color__white;
  }

  &__content {
    div {
      display: flex;
      padding: $default-margin-padding-width * 1.5 $default-margin-padding-width;
      border-top: .0625rem solid $color--input__border;
      cursor: pointer;

      &:hover {
        background-color: $color__page--background;
      }

      span {
        color: $color__text__default;
        width: 20.469rem;
        margin-right: $default-margin-padding-width * 1.5;
      }
    }

    .selected {
      background-color: $color__page--background;
      opacity: .9;
    }
  }
}

@include breakpoint-down($md) {
  .ccrs-search-results-popup {
    width: calc(100% - 1rem);
    margin-left: -1.5rem;

    &__header {
      span {
        margin-right: $default-margin-padding-width;
        min-width: 4rem;
      }
    }

    &__content {
      div {
        span {
          margin-right: $default-margin-padding-width;
          min-width: 4rem;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
